import { useEffect, useState } from "preact/hooks";

/** 低于这个宽度按移动端交互渲染。 */
const MOBILE_BREAKPOINT_PX = 640;
/**
 * 低于这个高度也使用移动布局，手机横屏就在这一档。桌面浮层上下至少各让 80px，
 * 再矮就放不下面板最小高度 420px，消息区只剩几行（GON-81）。
 */
const MOBILE_MAX_HEIGHT_PX = 580;
const MOBILE_QUERY = `(max-width: ${String(MOBILE_BREAKPOINT_PX - 1)}px), (max-height: ${String(MOBILE_MAX_HEIGHT_PX - 1)}px)`;

function matchesMobile(): boolean {
  return (
    typeof window.matchMedia === "function" &&
    window.matchMedia(MOBILE_QUERY).matches
  );
}

/**
 * 转屏和改窗口都要重新判断，所以挂监听而不是渲染时读一次。
 * 初值必须当场读：先按桌面画一帧的话，换页回来聊天窗开着时手机上会先闪出桌面聊天窗（GON-176）。
 */
export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(matchesMobile);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") {
      return;
    }

    const query = window.matchMedia(MOBILE_QUERY);
    const sync = () => {
      setMobile(query.matches);
    };

    sync();
    query.addEventListener("change", sync);

    return () => {
      query.removeEventListener("change", sync);
    };
  }, []);

  return mobile;
}
